var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandleSticks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 4.5C4.16667 3.94772 3.79357 3.5 3.33333 3.5C2.8731 3.5 2.5 3.94772 2.5 4.5V6.5C2.5 7.05228 2.8731 7.5 3.33333 7.5C3.79357 7.5 4.16667 7.05228 4.16667 6.5V4.5Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 12.5C4.16667 11.9477 3.79357 11.5 3.33333 11.5C2.8731 11.5 2.5 11.9477 2.5 12.5V18.5C2.5 19.0523 2.8731 19.5 3.33333 19.5C3.79357 19.5 4.16667 19.0523 4.16667 18.5V12.5Z",
    fill: "#777E91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16659 10.5V8.5C4.16659 7.94772 3.79349 7.5 3.33325 7.5C2.87301 7.5 2.49992 7.94772 2.49992 8.5V10.5C2.49992 11.0523 2.87301 11.5 3.33325 11.5C3.79349 11.5 4.16659 11.0523 4.16659 10.5ZM3.33325 5.5C1.95254 5.5 0.833252 6.84315 0.833252 8.5V10.5C0.833252 12.1569 1.95254 13.5 3.33325 13.5C4.71396 13.5 5.83325 12.1569 5.83325 10.5V8.5C5.83325 6.84315 4.71396 5.5 3.33325 5.5Z",
    fill: "#777E91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 8.5C10.8334 7.94772 10.4603 7.5 10.0001 7.5C9.53984 7.5 9.16675 7.94772 9.16675 8.5V11.5C9.16675 12.0523 9.53984 12.5 10.0001 12.5C10.4603 12.5 10.8334 12.0523 10.8334 11.5V8.5Z",
    fill: "#777E91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 18.5C10.8334 17.9477 10.4603 17.5 10.0001 17.5C9.53984 17.5 9.16675 17.9477 9.16675 18.5V20.5C9.16675 21.0523 9.53984 21.5 10.0001 21.5C10.4603 21.5 10.8334 21.0523 10.8334 20.5V18.5Z",
    fill: "#777E91"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8333 16.5V13.5C10.8333 12.9477 10.4602 12.5 10 12.5C9.53976 12.5 9.16667 12.9477 9.16667 13.5V16.5C9.16667 17.0523 9.53976 17.5 10 17.5C10.4602 17.5 10.8333 17.0523 10.8333 16.5ZM10 10.5C8.61929 10.5 7.5 11.8431 7.5 13.5V16.5C7.5 18.1569 8.61929 19.5 10 19.5C11.3807 19.5 12.5 18.1569 12.5 16.5V13.5C12.5 11.8431 11.3807 10.5 10 10.5Z",
    fill: "#777E91"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 4.5C17.4999 3.94772 17.1268 3.5 16.6666 3.5C16.2063 3.5 15.8333 3.94772 15.8333 4.5V6.5C15.8333 7.05228 16.2063 7.5 16.6666 7.5C17.1268 7.5 17.4999 7.05228 17.4999 6.5V4.5Z",
    fill: "#777E91"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 15.5C17.4999 14.9477 17.1268 14.5 16.6666 14.5C16.2063 14.5 15.8333 14.9477 15.8333 15.5V18.5C15.8333 19.0523 16.2063 19.5 16.6666 19.5C17.1268 19.5 17.4999 19.0523 17.4999 18.5V15.5Z",
    fill: "#777E91"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5001 13.5V8.5C17.5001 7.94772 17.127 7.5 16.6667 7.5C16.2065 7.5 15.8334 7.94772 15.8334 8.5V13.5C15.8334 14.0523 16.2065 14.5 16.6667 14.5C17.127 14.5 17.5001 14.0523 17.5001 13.5ZM16.6667 5.5C15.286 5.5 14.1667 6.84315 14.1667 8.5V13.5C14.1667 15.1569 15.286 16.5 16.6667 16.5C18.0475 16.5 19.1667 15.1569 19.1667 13.5V8.5C19.1667 6.84315 18.0475 5.5 16.6667 5.5Z",
    fill: "#777E91"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandleSticks);
export default __webpack_public_path__ + "static/media/candle-sticks.885c9a6076ce987dbfdf71d000ca3dc3.svg";
export { ForwardRef as ReactComponent };